import { VertexData } from '@babylonjs/core/Meshes/mesh.vertexData';
import type { VertexDataDesc } from './meshTypes';

/**
 * Creates vertex data from descriptor.
 * @param data - Vertex data descriptor.
 */
export function vertexDataCreate(data: VertexDataDesc): VertexData {
  const { indices, positions } = data;

  const vertexData = new VertexData();
  vertexData.indices = indices;
  vertexData.positions = positions;

  let normals = data.normals;
  if (normals === undefined) {
    normals = new Float32Array(positions.length);
    VertexData.ComputeNormals(positions, indices, normals, {
      useRightHandedSystem: true,
    });
    data.normals = normals;
  }
  vertexData.normals = normals;

  if (data.uvs) {
    vertexData.uvs = data.uvs;
  }

  return vertexData;
}
